<template>
  <div class="r-order-choose-craft">
    <div
      class="common-flex common-justify-between common-align-center"
      style="margin-bottom: 10px"
    >
      <div class="name">{{ config.name }}</div>
      <form
        v-if="
          config.children &&
          config.children.length > 0 &&
          config.children[0].sourceType != 'LABEL'
        "
      >
        <Select
          prefix="ios-search"
          @on-change="changeCraft"
          clearable
          style="width: 260px"
          :placeholder="$t('newOrder.placeCommon')"
          :not-found-text="$t('noDate')"
          filterable
        >
          <Option
            v-for="item in config.children"
            :value="item.id"
            :key="item.id"
            >{{ item.name }}</Option
          >
        </Select>
      </form>
    </div>
    <div
      class="common-flex common-flex-wrap common-align-center"
      style="width: 100%"
    >
      <div
        class="common-flex items"
        :style="[item.sourceType == 'LABEL' ? { width: '100%' } : {}]"
        v-for="(item, index) in config.children"
        :key="index"
      >
        <div v-if="item.sourceType == 'LABEL'" style="width: 100%">
          <rOrderChooseCraft
            @craftSelect="craftSelects"
            :config="item"
          ></rOrderChooseCraft>
        </div>
        <div v-if="item.sourceType == 'FONT'">
          <div
            :class="item.isDefault == 1 ? 'fonts-border' : ''"
            class="fonts common-hover"
            :style="[
              item.isDefault == 1
                ? { background: '#E6EDF9', color: '#0A4DCC' }
                : {},
            ]"
            @click="craftSelect(index, item)"
          >
            {{ item.name }}
          </div>
        </div>
        <div v-if="item.sourceType == 'IMAGE'">
          <rImageChoose
            :boxType="boxType"
            @select="craftSelect"
            :index="index"
            :config="item"
            marginRight="10px"
          ></rImageChoose>
        </div>

        <div v-if="item.sourceType == 'TEXT'">
          <div class="r-input-box" style="margin-top: 5px">
            <textarea
              :data-picIndex="index"
              class="input-box common-rowUnder"
              :placeholder="$t('pleaseIpt')"
              type="text"
              @focus="focus"
              v-model="item.value"
            ></textarea>
            <div class="box"></div>
            <div class="name">{{ item.name }}</div>
            <div v-if="item.isDefault" class="iconfont iconwancheng"></div>
          </div>
        </div>
      </div>
    </div>
    <!-- 存在子集并且选中当前列 -->
    <div v-if="nowItem && nowItem.children">
      <rOrderChooseCraft :config="nowItem"></rOrderChooseCraft>
    </div>
  </div>
</template>

<script>
import rImageChoose from "./r-image-choose";
export default {
  name: "rOrderChooseCraft",
  components: {
    rImageChoose,
  },
  data() {
    return {
      boxType: "craft",
      nowItem: "",
    };
  },
  props: {
    config: Object,
  },

  methods: {
    changeCraft(e) {
      // 选择当前选项
      if (e) {
        this.config.children.map((item, index) => {
          if (e == item.id) {
            item.isDefault = 1;
          } else {
            item.isDefault = 0;
          }
        });
      }
    },
    // 聚焦
    focus(e) {
      let picindex = e.target.dataset.picindex;
      this.config.children.map((item, index) => {
        if (picindex == index) {
          item.isDefault = 1;
        } else {
          item.isDefault = 0;
          item.value = "";
        }
      });
      // let item = JSON.parse(JSON.stringify(e));
      // this.config.children.splice(picindex, 1, e);
    },
    craftSelect(index, e) {
      if (this.config.chooseType == "RADIO") {
        //如果是单选
        if (e.isDefault == 0) {
          this.config.children.map((item) => {
            item.isDefault = 0;
            item.value = "";
          });
          e.isDefault = 1;
          this.nowItem = e;
        } else {
          e.isDefault = 0;
          e.value = "";
        }
        this.config.children.splice(index, 1, e);
      } else {
        e.isDefault = e.isDefault == 1 ? 0 : 1;
        this.nowItem = e.isDefault == 1 ? e : "";
        this.config.children.splice(index, 1, e);
      }

      this.$emit("craftSelect", e, this.config);
    },
    craftSelects(e, config) {
      this.$emit("craftSelect", e, config);
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
/deep/.ivu-select .ivu-select-dropdown {
  top: auto !important;
  max-width: 260px;
}
/deep/.ivu-select-item {
  word-wrap: break-word;
  word-break: normal;
  white-space: normal;
}
// /deep/.ivu-select-dropdown{
// }
.r-order-choose-craft {
  background: #fff;
  margin-bottom: 10px;
  padding: 10px;
  width: 100%;
  .name {
    // width: 74px;

    font-size: 14px;
    font-family: ArialMT;
    text-align: left;
    color: #081938;
    line-height: 16px;
    margin-bottom: 10px;
    // overflow: hidden;
    // text-overflow: ellipsis;
    // white-space: nowrap;
  }
  .r-input-box {
    // margin: 0 5px 15px;
    margin-right: 5px;
    position: relative;
    .iconwancheng {
      position: absolute;
      font-size: 24px;
      color: #003888;
      background: #fff;
      width: 24px;
      height: 24px;
      line-height: 24px;
      border-radius: 50%;
      top: 25px;
      opacity: 0.7;
      z-index: 99;
      // bottom: 0;
      left: 0;
      right: 0;
      margin: auto;
    }
    .input-box {
      width: 74px;
      height: 74px;
      border: 1px solid rgba(8, 25, 56, 0.3);
      resize: none;
      outline: none;
      padding: 9px 8px;
      border-radius: 5px;
      position: relative;
      z-index: 9;
    }
    .name {
      width: 74px;
      font-size: 12px;
      font-weight: 400;
      text-align: center;
      color: #081938;
      line-height: 14px;
      margin-top: 10px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  .input-box::-webkit-input-placeholder {
    font-size: 12px;
    // transform: scale(.7);
  }
  .fonts {
    // width: 60px;
    padding: 0 10px;
    height: 26px;
    background: #f8f8f8;
    color: #979eaa;
    line-height: 26px;
    text-align: center;
    font-size: 12px;
    position: relative;
    margin-bottom: 5px;
  }
  .fonts-border::after {
    content: "";
    position: absolute;
    width: 100%;
    height: 26px;
    left: 0;
    top: 0;
    border: 1px solid #0a4dcc;
  }
  .fonts {
    margin-right: 5px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/r-order-choose-craft.vue